<script>
import first from 'lodash-es/first';

export default {
    methods: {
        getBindRelations(type) {
            return this.data.config.bindTo
                .filter(x => x.type === type)
                .map(x => x.name);
        },
        getBindRelation(type) {
            return first(this.getBindRelations(type));
        },
    },
};
</script>
